import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Moma Design Studio
 * id 58C2BC63-FCF5-445B-B351-23CF48253FEF
 * name stairs-box
 * version: 5.0.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/stairs-box.svg
 * tags
 */
export const StairsBoxIcon = createSvgIcon(<><path d="M5 3C3.89 3 3 3.89 3 5V19C3 20.11 3.89 21 5 21H19C20.11 21 21 20.11 21 19V5C21 3.89 20.11 3 19 3H5M14 7H19V9H16V12H13V15H10V18H5V16H8V13H11V10H14V7Z" /></>, 'StairsBoxIcon');
export default StairsBoxIcon